import {useAuth, useLocalStorage} from 'bigdatr-style';
import {
    pointToProductionLocalStorageKey,
    teamsAllowedToAccessProductionFromStaging
} from 'bigdatr-style/src/core/auth/pointingToProductionDataHelpers';

export default function useGetPointingStagingToProductionData() {
    const isStagingEnvironment = process.env.STAGE === 'staging';
    const {teamId} = useAuth();
    const [pointStagingToProduction, setPointStagingToProduction] = useLocalStorage(
        pointToProductionLocalStorageKey,
        false
    );

    if (!isStagingEnvironment || !teamId) {
        return {
            isAllowedToPointStagingToProduction: false,
            pointStagingToProduction: false,
            setPointStagingToProduction: (_next: boolean) => {}
        };
    }

    const currentTeamCanPointStagingToProduction = [
        ...teamsAllowedToAccessProductionFromStaging.values()
    ].includes(teamId);

    const isAllowedToPointStagingToProduction =
        isStagingEnvironment && currentTeamCanPointStagingToProduction;

    return {
        isAllowedToPointStagingToProduction,
        pointStagingToProduction,
        setPointStagingToProduction
    };
}
